import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../../Table'

import { renderCell } from './DocFlowSendingEpostValidationErrorsReportModalRow.utils'

import * as styles from './DocFlowSendingEpostValidationErrorsReportModalRow.module.css'

function DocFlowSendingEpostValidationErrorsReportModalRow({
  Actions = TableRowActions,
  columns,
  disabled,
  emptyColumnSize,
  emptyCommunicationRecipients,
  isSelected,
  item,
  saveToProfileIds,
  sendAdditionalEmailIds,
  sendEmailIds,
  onOpenValidationPreview,
  onSelect,
  onToggleSaveToProfile,
  onToggleSendAdditionalEmail,
  onToggleSendEmail,
}) {
  const { t } = useTranslation()

  const { handleSelect } = useTableRowActions({ item, onSelect })

  const qaProps = getTableRowQaProps()

  const className = useTableRowModClassName({
    className: styles.DocFlowSendingEpostValidationErrorsReportModalRow,
    isSelected,
  })

  function handleToggleSaveToProfile(value) {
    onToggleSaveToProfile({ item, value })
  }

  function handleToggleSendEmail(value) {
    onToggleSendEmail({ item, value })
  }

  function handleToggleSendAdditionalEmail(value) {
    onToggleSendAdditionalEmail({ item, value })
  }

  function handleOpenValidationPreview() {
    onOpenValidationPreview(item)
  }

  return (
    <div {...qaProps} className={className} key={item.id}>
      {Actions ? (
        <Actions
          checked={isSelected}
          disabled={disabled}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            emptyCommunicationRecipients,
            item,
            name: column.name,
            saveToProfileIds,
            sendAdditionalEmailIds,
            sendEmailIds,
            t,
            width: column.width,
            onOpenValidationPreview: handleOpenValidationPreview,
            onToggleSaveToProfile: handleToggleSaveToProfile,
            onToggleSendAdditionalEmail: handleToggleSendAdditionalEmail,
            onToggleSendEmail: handleToggleSendEmail,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default DocFlowSendingEpostValidationErrorsReportModalRow
